import { render, staticRenderFns } from "./Typography6.vue?vue&type=template&id=5e16fac3&scoped=true"
import script from "./Typography6.vue?vue&type=script&lang=js"
export * from "./Typography6.vue?vue&type=script&lang=js"
import style0 from "./Typography6.vue?vue&type=style&index=0&id=5e16fac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e16fac3",
  null
  
)

export default component.exports